// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__31H_A","error":"Textarea_error__1JbLn","readonly":"Textarea_readonly__3jYqS","disabled":"Textarea_disabled__2Xn7a"};